<template>
  <div class="container-fluid pb-5">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="card shadow-sm border-0 rounded-lg">
          <div class="card-body p-3">
            <h2 class="title-content mb-3 text-left text-primary">Booking Details</h2>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Guest Name: </h5>
                  <p class="mb-0 fw-bold">{{ booking.user.name }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Phone: </h5>
                  <p class="mb-0 fw-bold">{{ booking.user.mobile_phone }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Check-in Date: </h5>
                  <p class="mb-0 fw-bold">{{ booking.start_date }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Guests: </h5>
                  <p class="mb-0 fw-bold">{{ booking.number_of_guests }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Pets: </h5>
                  <p class="mb-0 fw-bold">{{ booking.pets_count }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Email: </h5>
                  <p class="mb-0 fw-bold">{{ booking.user.email }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Booking Date: </h5>
                  <p class="mb-0 fw-bold">{{ booking.start_date }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Check-out Date: </h5>
                  <p class="mb-0 fw-bold">{{ booking.end_date }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Children: </h5>
                  <p class="mb-0 fw-bold">{{ booking.childrens_count }}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Status: </h5>
                  <p class="mb-0 fw-bold">Confirmed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Invoice History Card -->
        <div class="card shadow-sm border-0 rounded-lg mt-4">
          <div class="card-body p-4">
            <h2 class="title-content mb-3 text-left text-primary">Invoice History</h2>
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Subtotal Amount: </h5>
                  <p class="mb-0 fw-bold">{{ booking.payment_currency }} {{ payment.subtotalAmount }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Discount Amount: </h5>
                  <p class="mb-0 fw-bold">{{ booking.payment_currency }} {{ booking.discount_amount }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Total Amount Paid: </h5>
                  <p class="mb-0 fw-bold">{{ booking.payment_currency }} {{ payment.totalAmountPaid }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Total Installments: </h5>
                  <p class="mb-0 fw-bold">{{ payment.totalInstallments }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Extra Days Payment: </h5>
                  <p class="mb-0 fw-bold">{{ booking.payment_currency }} {{ payment.extraDaysPayment }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Discounts %: </h5>
                  <p class="mb-0 fw-bold">{{ booking.discount_percentage }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Total Payable: </h5>
                  <p class="mb-0 fw-bold">{{ booking.payment_currency }} {{ payment.totalPayable }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Remaining Amount: </h5>
                  <p class="mb-0 fw-bold">{{ booking.payment_currency }} {{ payment.remainingAmount }}</p>
                </div>
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Remaining Installments: </h5>
                  <p class="mb-0 fw-bold">{{ payment.remainingInstallments }}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="listing-content d-flex flex-wrap align-items-center gap-3 mb-2">
                  <h5 class="mb-0 me-2">Commission: </h5>
                  <p class="mb-0 fw-bold">{{ booking.payment_currency }} {{ payment.commission }}</p>
                </div>
              </div>
            </div>

            <!-- Vue Good Table -->
            <h3 class="mt-4 title-content mb-3 text-left text-primary">Payments</h3>
            <div class="booking-table">
              <vue-good-table :columns="columns" :rows="invoices" :search-options="{ enabled: false }"
                :pagination-options="{ enabled: true, perPage: 5 }" styleClass="table table-bordered table-hover">
                <template #table-row="props">
                  <span v-if="props.column.field === 'status'">
                    <span :class="[
                      'px-2 py-1 rounded text-white',
                      props.row.status === 'Paid' ? 'bg-success' :
                        props.row.status === 'Active' ? 'bg-primary' :
                          props.row.status === 'Pending' ? 'bg-warning' :
                            props.row.status === 'Failed' ? 'bg-danger' : ''
                    ]">
                      {{ props.row.status }}
                    </span>
                  </span>
                  <span v-else-if="props.column.field === 'amount'">
                    {{ booking.payment_currency }} {{ props.row.amount }}
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import API from '@/api';

export default {
  components: {
    VueGoodTable
  },
  data() {
    return {
      booking: {},
      payment: {},
      invoices: [],
      currency: '',
      columns: [
        { label: 'Transaction ID', field: 'transactionId', sortable: false },
        { label: 'Date', field: 'date', sortable: false },
        { label: 'Amount', field: 'amount', sortable: false },
        { label: 'Type', field: 'type', sortable: false },
        { label: 'Status', field: 'status', sortable: false }
      ]
    };
  },
  created() {
    const bookingId = this.$route.params.id;
    if (bookingId) {
      this.fetchBooking(bookingId);
    }
  },
  watch: {
    '$route.params.id'(newId) {
      if (newId) {
        this.fetchBooking(newId);
      }
    }
  },
  methods: {
    fetchBooking(id) {
      API.getBookingById(id,
        (res) => {
          this.booking = res.data;
          this.payment = res.meta;
          this.currency = res.data.payment_currency || '--';
          this.invoices = res.meta.invoices || [];
        },
        (err) => {
          this.booking = {};
          this.payment = {};
          this.invoices = [];
          console.error('Failed to fetch booking:', err);
        }
      );
    },
    formatCurrency(amount) {
      if (!amount) return `${this.currency} 0.00`;
      return `${this.currency} ${parseFloat(amount).toFixed(2)}`;
    }
  }
};
</script>

<style scoped>
.card {
  border-radius: 1.5rem;
}

th,
td {
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}

thead th:first-child {
  border-left: 1px solid #dee2e6 !important;
}

thead th:last-child {
  border-right: 1px solid #dee2e6 !important;
}

.listing-content h5 {
  width: 30%;
}

.card .title-content {
  font-size: 22px;
}

.client-dashbboard .main-panel .card {
  padding: 0;
}

@media (max-width: 1199px) {
  .listing-content h5 {
    width: 40%;
  }
}

@media (max-width: 767px) {
  .client-dashbboard .main-panel .content-wrapper {
    padding: 25px 0 !important;
  }
}

@media (max-width: 574px) {
  .listing-content h5 {
    width: 50%;
    font-size: 14px;
  }

  .container-fluid {
    padding: 15px 0 0;
  }
}
</style>
